import { render, staticRenderFns } from "./MessageTemplateEventModal.vue?vue&type=template&id=2ba6f890&scoped=true&"
import script from "./MessageTemplateEventModal.vue?vue&type=script&lang=js&"
export * from "./MessageTemplateEventModal.vue?vue&type=script&lang=js&"
import style0 from "./MessageTemplateEventModal.vue?vue&type=style&index=0&id=2ba6f890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba6f890",
  null
  
)

export default component.exports